import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const toasts = ref([])
  const toastIntervals = ref(new Map()) // ✅ เก็บ intervals ทั้งหมดเพื่อ cleanup
  let nextId = 1

  const addToast = (options) => {
    const toast = {
      id: nextId++,
      type: options.type || 'info',
      title: options.title || null,
      message: options.message || '',
      duration: options.duration !== undefined ? options.duration : 4000,
      progress: 100
    }

    toasts.value.push(toast)

    // Auto remove toast after duration
    if (toast.duration > 0) {
      let progress = 100
      const interval = setInterval(() => {
        progress -= 2
        const toastIndex = toasts.value.findIndex(t => t.id === toast.id)
        if (toastIndex !== -1) {
          toasts.value[toastIndex].progress = progress
        }

        if (progress <= 0) {
          clearInterval(interval)
          toastIntervals.value.delete(toast.id) // ✅ ลบออกจาก Map
          removeToast(toast.id)
        }
      }, toast.duration / 50)

      // ✅ เก็บ interval ไว้ใน Map เพื่อ cleanup ภายหลัง
      toastIntervals.value.set(toast.id, interval)
    }

    return toast.id
  }

  const removeToast = (id) => {
    // ✅ Clear interval ก่อนลบ toast
    if (toastIntervals.value.has(id)) {
      clearInterval(toastIntervals.value.get(id))
      toastIntervals.value.delete(id)
    }

    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  const clearAll = () => {
    // ✅ Clear ทุก intervals ก่อนลบ toasts
    toastIntervals.value.forEach(interval => clearInterval(interval))
    toastIntervals.value.clear()
    toasts.value = []
  }

  // ✅ Cleanup function สำหรับเรียกเมื่อ app shutdown
  const cleanup = () => {
    toastIntervals.value.forEach(interval => clearInterval(interval))
    toastIntervals.value.clear()
  }

  // Convenience methods
  const success = (message, options = {}) => {
    return addToast({ ...options, type: 'success', message })
  }

  const error = (message, options = {}) => {
    return addToast({ ...options, type: 'error', message, duration: options.duration || 6000 })
  }

  const warning = (message, options = {}) => {
    return addToast({ ...options, type: 'warning', message })
  }

  const info = (message, options = {}) => {
    return addToast({ ...options, type: 'info', message })
  }

  return {
    toasts,
    addToast,
    removeToast,
    clearAll,
    cleanup, // ✅ Export cleanup function
    success,
    error,
    warning,
    info
  }
})